import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31e4994f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "主题风格", -1))
const _hoisted_2 = { class: "themes" }

import { toRef } from 'vue'
import { themeStore } from '@/stores'

import ThemeCard from '@/components/profile-preferences/ThemeCard.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ThemeList',
  setup(__props) {

const themes = toRef(themeStore.state, 'themes')

const setTheme = (theme: Theme) => themeStore.setTheme(theme)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(themes), (theme) => {
        return (_openBlock(), _createElementBlock("li", {
          key: theme.id,
          "data-testid": "theme-card"
        }, [
          (_openBlock(), _createBlock(ThemeCard, {
            key: theme.id,
            theme: theme,
            onSelected: setTheme
          }, null, 8, ["theme"]))
        ]))
      }), 128))
    ])
  ]))
}
}

})